export default "__VITE_ASSET__XkA4e$ST__"